import React, { useEffect, useState } from "react";
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { motion } from "framer-motion";
import obrazek from "../images/banner-images/banner-image-1.jpg";
import { builder } from '../utils/builderWithLocale';
import { entryMatchesId, getBikeField, getCategoryReferenceIds } from '../editry/cms';
import { NavLink, useParams } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useSwipeable } from 'react-swipeable';
import { getLocalizedText } from '../utils/textLocalization';
import ReactPlayer from "react-player/lazy";

function App() {
  // Get localized text
  const goToBikeText = getLocalizedText('general.go_to_bike');
  
  const { id } = useParams();
  const [novinka, setNovinka] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [galerie, setGalerie] = useState([]);
  const [refKola, setRefKola] = useState([]);
  const [allBikes, setAllBikes] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [imageSize, setImageSize] = useState("short");

  useEffect(() => {
    setIsLoading(true);
    document.title = "Ridley | Novinka"
    builder.getAll('novinky')
      .then(function (response) {
        let allNovinky = [];
        
        if (Array.isArray(response)) {
          allNovinky = response;
        } else if (typeof response === 'object') {
          Object.keys(response).forEach(key => {
            if (Array.isArray(response[key])) {
              allNovinky = response[key];
            }
          });
        }
        
        const numericId = parseInt(id, 10);
        const indexToFind = isNaN(numericId) ? id : numericId - 1;
        
        let found;
        if (isNaN(numericId)) {
          found = allNovinky.find(item => item.data.route === id);
        } else {
          found = allNovinky[indexToFind];
        }

        if (found) {
          document.title = "Ridley | " + (found.data.title);
          setNovinka(found);
          
          // Always use image for gallery (video will be displayed separately)
          if (found.data.galerie && found.data.galerie.length > 0) {
            setGalerie([
              { fotka: found.data.image },
              ...found.data.galerie
            ]);
          } else {
            setGalerie([{ fotka: found.data.image }]);
          }

          // Handle multiple bikes (new format) or single bike (old format for backwards compatibility)
          const bikeReferences = found.data.kola || (found.data.kolo ? [{ kolo: found.data.kolo }] : []);
          
          if (bikeReferences.length > 0) {
            // Make single API calls to get all bikes and categories
            Promise.all([
              builder.getAll("kola"),
              builder.getAll("pick-4")
            ]).then(([allBikesResponse, allCategoriesResponse]) => {
              const allBikes = allBikesResponse;
              
              // Process each bike reference and find matching bike data
              const matchedBikes = [];
              
              bikeReferences.forEach(bikeRef => {
                const bikeId = String(bikeRef.kolo.id);
                const foundBike = allBikes.find((bike) => entryMatchesId(bike, bikeId));
                
                if (foundBike) {
                  const kategorieIds = getCategoryReferenceIds(foundBike.data?.kategorie);
                  const foundKategorie = allCategoriesResponse.find((cat) =>
                    kategorieIds.some((kategorieId) => entryMatchesId(cat, kategorieId))
                  );
                  
                  matchedBikes.push({
                    bikeData: foundBike.data,
                    bikeId: foundBike.id,
                    kategorieCesta: foundKategorie?.data?.cesta || ""
                  });
                }
              });
              
              setRefKola(matchedBikes);
            }).catch(error => {
              console.error("Error loading bikes and categories:", error);
            });
          }
        }
        setIsLoading(false);
      })
      .catch(error => {
        console.error("Nepodařilo se načíst novinky:", error);
        setIsLoading(false);
      });
  }, [id]);

  const [galleryid, setGalleryid] = useState(0);

  const nxtGallery = () => {
    if (galleryid < galerie.length - 1) {
      setGalleryid(galleryid + 1);
      return;
    } else {
      setGalleryid(0);
      return;
    }
  }

  const prvGallery = () => {
    if (galleryid !== 0) {
      setGalleryid(galleryid - 1);
      return;
    } else {
      setGalleryid(galerie.length - 1);
      return;
    }
  }

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => nxtGallery(),
    onSwipedRight: () => prvGallery(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });



  useEffect(() => {
  if (!galerie[galleryid]?.fotka) return;

  const img = new Image();
  img.src = galerie[galleryid].fotka;

  img.onload = () => {
    if (img.naturalHeight >= img.naturalWidth) {
      setImageSize("long");
    } else {
      setImageSize("short");
    }
  };
}, [galleryid, galerie]);


  return (
    <>
      <motion.div className="page article-example" key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
      {isLoading ? (
          <div className="loading-container" />
        ) : novinka && novinka.data ? (
          <>



            <div className={imageSize === "long" ? "article-gallery article-image-long" : "article-gallery article-image-short"}>
                <div className="article-gallery-blocker" {...swipeHandlers}>
                  <AnimatePresence mode="wait">
                    {galerie.map((item, index) => (
                      galleryid === index && (
                        <motion.img
                          key={index}
                          src={item.fotka || obrazek}
                          alt={novinka.data.title || "Článek"}
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 0 }}
                          transition={{ duration: 0.1 }}
                        />
                      )
                    ))}
                  </AnimatePresence>
                </div>
              <div className="article-gallery-buttons">
                {galerie.length > 1 && (
                <>
                <button onClick={() => {prvGallery()}} className="gallery-button-left"><MdKeyboardArrowLeft /></button>

                {galerie.map((item, index) => (
                <button onClick={() => {setGalleryid(index)}} className={galleryid === index && "gallery-active-button"}></button>
                ))}

                <button onClick={() => {nxtGallery()}} className="gallery-button-right"><MdKeyboardArrowRight /></button>
                </>
                )}
              </div>
            </div>




            <h1>{novinka.data.title}</h1>
            <p dangerouslySetInnerHTML={{ __html: novinka.data.description}} className="html-unblock-article news-image-content"/>

            {novinka.data.video && (
              <div className="article-video">
                <ReactPlayer 
                  url={novinka.data.video} 
                  controls={true}
                  width="100%"
                  height="100%"
                />
              </div>
            )}

            {/* Render multiple bikes */}
            {refKola.length > 0 && refKola.map((bikeInfo, index) => (
              <NavLink 
                key={index} 
                to={"/kola/" + bikeInfo.kategorieCesta + "/" + bikeInfo.bikeId}
              >
                <div className="article-bike">
                  <img src={bikeInfo.bikeData.obrazek + "?format=webp"} alt={bikeInfo.bikeData.nazev || "Bike"} />
                  <h3>{bikeInfo.bikeData.nazev}</h3>
                  <h4>{getBikeField(bikeInfo.bikeData, 'oProduktu')}</h4>
                  <button><label>{goToBikeText}</label></button>
                </div>
              </NavLink>
            ))}

          </>
        ) : (
          <div className="loading-container" />
        )}
      </motion.div>
    </>
  );
}

export default App;